import { mainSiteUrl } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative w-full h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Minimalist%20warm%20toned%20fashion%20flatlay%20with%20designer%20sneakers%20and%20neutral%20colored%20hoodies%20and%20accessories%20arranged%20aesthetically%20on%20light%20concrete%20surface%20with%20soft%20natural%20lighting%20from%20left%20side%20creating%20gentle%20shadows%20clean%20modern%20editorial%20composition%20warm%20beige%20and%20cream%20tones%20high%20detail%20professional%20product%20photography&width=1920&height=1080&seq=hero-bg-main-2026&orientation=landscape"
        alt="CSSBuy Spreadsheet Directory - Premium streetwear and sneaker finds"
        title="CSSBuy Spreadsheet Directory - Premium streetwear and sneaker finds"
        className="absolute inset-0 w-full h-full object-cover object-center"
        loading="eager"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-8">
          <i className="ri-sparkling-line text-white/90 text-sm"></i>
          <span className="text-white/90 text-xs font-medium tracking-wider uppercase">Updated Weekly · 2026 Edition</span>
        </div>

        <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
          The Most Complete<br />
          <span className="text-primary-300">CSSBuy Spreadsheet</span> Directory
        </h2>

        <p className="text-white/70 text-lg md:text-xl max-w-2xl mx-auto mb-10 leading-relaxed">
          Discover thousands of verified sneaker, clothing, and luxury product spreadsheets — updated weekly with the latest finds, quality-checked listings, and organized categories for smart shoppers.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-white text-foreground-900 font-semibold text-base hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            CSSBuy Sheet
            <i className="ri-arrow-right-up-line"></i>
          </a>
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-base hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
          >
            Buy It Now
            <i className="ri-shopping-bag-line"></i>
          </a>
        </div>

        <div className="mt-16 flex items-center justify-center gap-8 text-white/50 text-sm">
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>Updated Weekly</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>Quality Checked</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-check-line text-accent-400"></i>
            <span>14 Categories</span>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a href="#categories" className="text-white/50 hover:text-white/80 transition-colors duration-200 cursor-pointer">
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>
    </section>
  );
}